import type { BoxProps } from '@chakra-ui/react';
import { PRODUCT_CARD_RATIO } from 'components/product/ProductCard/ProductCardImage';
import { useAnalytics } from 'hooks/useAnalytics';
import { useBannerCard } from 'hooks/useBannerCard';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { BannerCardContent, type BannerCardVariant } from './BannerCardContent';

export type { BannerCardVariant };

interface BannerCardProps extends BoxProps {
  variant?: BannerCardVariant;
  onDisplay?: () => void;
}

export const BannerCard = ({
  variant = 'default',
  onDisplay,
  ...props
}: BannerCardProps) => {
  const pathname = usePathname();
  const { analytics } = useAnalytics();
  const { data: skincareCard } = useBannerCard();

  useEffect(() => {
    if (!skincareCard) return;

    onDisplay?.();
  }, [skincareCard, onDisplay]);

  if (!skincareCard) return null;

  return (
    <BannerCardContent
      display="flex"
      flexDirection="column"
      borderRadius="base"
      aspectRatio={variant === 'wide' ? 'auto' : PRODUCT_CARD_RATIO}
      paddingX={variant === 'wide' ? 'lg' : 'sm'}
      paddingY="lg"
      variant={variant}
      card={skincareCard}
      onCtaClick={(url) => {
        analytics.skincareCardClick({ slug: pathname || '', url });
      }}
      {...props}
    />
  );
};
